import React from "react";
import { Post } from "@pulsex/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTelegram,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  handleFacebookShare,
  handleTelegramShare,
  handleTwitterShare,
  handleWhatsAppShare,
} from "@pulsex/utils";

const SocialsList = ({ post }: { post: Post }) => {
  return (
    <div className="opacity-80 flex gap-3 my-3 text-black dark:text-white">
      <button
        className="cursor-pointer"
        onClick={() => handleShare("facebook", post)}
      >
        <FontAwesomeIcon
          icon={faFacebook}
          size="lg"
          color="rgb(238, 111, 31)"
        />
      </button>
      <button
        className="cursor-pointer"
        onClick={() => handleShare("twitter", post)}
      >
        <FontAwesomeIcon
          icon={faXTwitter}
          size="lg"
          color="rgb(238, 111, 31)"
        />
      </button>
      <button
        className="cursor-pointer"
        onClick={() => handleShare("telegram", post)}
      >
        <FontAwesomeIcon
          icon={faTelegram}
          size="lg"
          color="rgb(238, 111, 31)"
        />
      </button>
      <button
        className="cursor-pointer"
        onClick={() => handleShare("whatsapp", post)}
      >
        <FontAwesomeIcon
          icon={faWhatsapp}
          size="lg"
          color="rgb(238, 111, 31)"
        />
      </button>
    </div>
  );
};

export default SocialsList;

const handleShare = (platform: string, post: Post) => {
  switch (platform) {
    case "facebook":
      handleFacebookShare(
        post?.title,
        post?.shortUrl
          ? post?.shortUrl
          : "https://english.almayadeen.net/" + post?.url
      );
      break;
    case "twitter":
      handleTwitterShare(
        post?.title,
        post?.shortUrl
          ? post?.shortUrl
          : "https://english.almayadeen.net/" + post?.url
      );
      break;
    case "telegram":
      handleTelegramShare(
        post?.title,
        post?.shortUrl
          ? post?.shortUrl
          : "https://english.almayadeen.net/" + post?.url
      );
      break;
    case "whatsapp":
      handleWhatsAppShare(
        post?.title,
        post?.shortUrl
          ? post?.shortUrl
          : "https://english.almayadeen.net/" + post?.url
      );
      break;
    default:
      break;
  }
};
